// @core/api/endpoints/task/delete_task_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete task type
 * Deactivates a task type definition. Existing task-aware entities of this type are not affected.
 */
export async function DeleteTaskType(
  type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
